import * as React from 'react';
import styled from '@emotion/styled';
import { useFieldArray } from 'react-hook-form';
import { FaTrashAlt, FaPlus } from 'react-icons/fa';
import { buildEmptyGenericMatcherFields, buildEmptyModstepMatcherFields, } from '../../../hooks/dlq-ignore-rules-api';
import { IconButton, InstructionsSmall, Row, Title4 } from '../../../components';
import { GenericMatcherForm } from './generic-matcher-form';
const Styles = styled.div `
  margin: 0.5rem 0;
  padding: 0.25rem 0.5rem;
  background: white;
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`;
const MatcherHeading = styled.div `
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;
export const ModInfoMatchersFieldArray = ({ form, index }) => {
    const name = `modplanMatchers.${index}.modInfoInputs`;
    const { fields, remove, append } = useFieldArray({ name, control: form.control });
    return (React.createElement("div", null,
        fields.map((item, i) => (React.createElement(GenericMatcherForm, { key: item.id, form: form, item: item, index: i, remove: remove, keyPrefix: name }))),
        React.createElement(Row, null,
            React.createElement(IconButton, { type: "button", onClick: () => {
                    append(buildEmptyGenericMatcherFields());
                } },
                React.createElement(FaPlus, null)))));
};
export const ModStepMatchersFieldArray = ({ form, index }) => {
    const name = `modplanMatchers.${index}.modStepInputs`;
    const { fields, remove, append } = useFieldArray({ name, control: form.control });
    return (React.createElement("div", null,
        fields.map((item, i) => (React.createElement(GenericMatcherForm, { key: item.id, form: form, item: item, index: i, remove: remove, keyPrefix: name }))),
        React.createElement(Row, null,
            React.createElement(IconButton, { type: "button", onClick: () => {
                    append(buildEmptyModstepMatcherFields());
                } },
                React.createElement(FaPlus, null)))));
};
export const ModplanMatcherForm = (props) => (React.createElement(Styles, null,
    React.createElement(MatcherHeading, null,
        React.createElement(Title4, null,
            "#",
            props.index + 1),
        React.createElement(Title4, null, "ModInfo Matchers"),
        React.createElement(InstructionsSmall, null, "reminder: all ModInfo matchers must match for a modplan matcher to match, they act as AND")),
    React.createElement(ModInfoMatchersFieldArray, Object.assign({}, props)),
    React.createElement(MatcherHeading, null,
        React.createElement(Title4, null, "ModStep Matchers"),
        React.createElement(InstructionsSmall, null, "reminder: all ModStep matchers must match for a modplan matcher to match, they act as AND")),
    React.createElement(ModStepMatchersFieldArray, Object.assign({}, props)),
    React.createElement(IconButton, { type: "button", onClick: () => props.remove(props.index) },
        React.createElement(FaTrashAlt, null))));
//# sourceMappingURL=modplan-matcher-form.js.map